import * as z from "zod/v4";

export const getCustomerSubscriptionTotalSpent = {
  name: "getCustomerSubscriptionTotalSpent" as const,
  input: z.object({
    customerId: z.number(),
  }),
  output: z.object({
    totalSpent: z.string(),
    totalCharges: z.number(),
  }),
};
